<template>
<div v-if="pageData" class="c-mv2" :class="{'c-mv2--vertical': isVertical, 'c-mv2--horizonal': !isVertical}">
  <div v-if="!isVertical" class="c-mv2__main">
    <span class="is-wrap">
      <span :style="styleSet"></span>
    </span>
  </div>
  <div v-if="isVertical" class="c-mv2__main">
    <span class="is-shape" :style="styleShape"></span>
    <span class="is-wrap">
      <img :src="pageData.photo.src" alt="" width="750" height="1259" />
    </span>
  </div>

  <div class="c-mv2__info">
    <h2 :class="{'is-blend': isBlend}" :style="{'color': colorCode}">
      <span v-for="line in pageData.info.title" :key="line">
        <span class="is-line">{{line}}</span>
      </span>
    </h2>
    <div class="is-text">
      <p v-if="pageData.info.text" v-html="pageData.info.text"></p>
      <a v-if="pageData.modal" class="c-btnView" href="#" @click.prevent="openModal">
        <span>VIEW MORE</span>
      </a>
    </div>
  </div>
</div>
</template>

<script>
// import SampleHelper from '@/_functions/SampleHelper';
// const {getUser, setUser, editUser} = SampleHelper();

import {gsap, Power3, Expo} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  data() {
    return {
      pageData: null,
      modal: null,
      shapeSize: 1174 / 750 * 100,
      isVertical: false,
      isBlend: false,
      colorCode: '',
      styleSet: {
        'background-image': ''
      }
    }
  },
  props: ['name'],
  computed: {
    styleShape() {
      return {paddingTop: `${this.shapeSize}%`};
    }
  },
  mounted() {
    // ページデータ
    this.pageData = this.$store.getters.pageData[this.name];
    // モーダル
    this.modal = this.pageData.modal;

    // 画像 横or縦
    const img = new Image();
    img.onload = () => {
      this.loaded({width: img.width, height: img.height});
    }
    img.src = this.pageData.photo.src;

    // タイトル文字色設定
    if (this.pageData.info.color) {
      this.colorCode = `${this.pageData.info.color}`;
    } else {
      this.isBlend = true;
    }
  },
  methods: {
    once() {
      // 画像表示
      const photo = this.$el.querySelector('.c-mv2__main .is-wrap');
      let viewPhoto = gsap.timeline({
        onComplete: this.showPhoto,
        scrollTrigger: {
          trigger: this.$el,
          start: 'top bottom',
          end: 'top 10%',
          once: true,
          scrub: true,
          // markers: true,
        }
      });

      viewPhoto.addLabel('start')
      .fromTo(photo, {
        scale: 1.3,
        y: '-50%',
      }, {
        duration: 1.0,
        scale: 1,
        y: '0%',
        ease: 'none',
      }, 'start');

      // テキスト表示
      const blockText = this.$el.querySelector('.c-mv2__info');
      const lines = blockText.querySelectorAll('.is-line');
      const texts = blockText.querySelector('.is-text');
      let viewTitle = gsap.timeline({
        scrollTrigger: {
          trigger: blockText,
          start: 'top 70%',
          end: 'top 40%',
          once: true,
          // scrub: 0.7,
          // markers: true,
        }
      });

      viewTitle
      .fromTo(lines, {
        y: '100%',
      }, {
        duration: 1.0,
        y: '0%',
        ease: Power3.easeOut,
        stagger: 0.1,
      });


      let viewText = gsap.timeline({
        scrollTrigger: {
          trigger: texts,
          start: 'top 70%',
          end: 'top 40%',
          once: true,
          // scrub: 0.7,
          // markers: true,
        }
      });

      viewText.fromTo(texts.children, {
        opacity: 0,
        y: '20%',
      }, {
        duration: 1.0,
        opacity: 1,
        y: '0%',
        ease: Power3.easeOut,
        stagger: 0,
      });
    },
    showPhoto() {
      this.$el.classList.add('c-mv2--loop');
      const photo = this.$el.querySelector('.c-mv2__main .is-wrap');
      gsap.set(photo, {clearProps: 'all'});
    },
    openModal() {
      this.$store.commit('setCurrentModal', this.$store.getters.modalData[this.modal]);
      this.$store.commit('setShowModal', true);
    },
    loaded(e) {
      if (e.width > e.height) {
        // 横画像はbackground
        this.isVertical = false;
        this.styleSet['background-image'] = `url(${this.pageData.photo.src}), url(${this.pageData.photo.src}), url(${this.pageData.photo.src})`;
      } else {
        this.isVertical = true;
        this.shapeSize = e.height / e.width * 100;
      }

      this.$nextTick(this.once);
    },
  }
}
</script>